<div class="container-fluid h-100">
  <div class="row">
    <div class="col-12">
      <span class="title">{{ content.title }}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p-divider styleClass="divider-m-5"></p-divider>
    </div>
  </div>
  <div class="container-fluid pb-3 container-content">
    <div class="row" *ngFor="let teamMember of teamMembers">
      <div class="col-12">
        <div class="flex-container">
          <div class="flex-item img-width">
            <img [src]="teamMember.profilePicBase64 ? teamMember.profilePicBase64 : 'assets/profile.png'" alt="Profile picture" />
          </div>
          <div class="flex-item content-width">
            <div>
              <span class="name" [ngClass]="{'myself': teamMember.name?.toLowerCase() === 'you'}"
                title="{{ teamMember.name }}">{{ teamMember.name }} | {{ teamMember.id ? teamMember.id : 'N/A' }}</span>
            </div>
            <div>
              <span class="description" title="{{ teamMember.status ? teamMember.status : 'N/A' }}
              | {{ teamMember.designation ? teamMember.designation : 'N/A' }}">{{ teamMember.status ? teamMember.status
                : 'N/A' }}
                | {{ teamMember.designation ? teamMember.designation : 'N/A' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!teamMembers || teamMembers.length === 0">
      <div class="col-12">
        <span class="no-data">No data available.</span>
      </div>
    </div>
  </div>
  <!-- <div class="row pb-3">
    <div class="col-12 text-center">
      <a class="link">{{ content.footerLink }}</a>
    </div>
  </div> -->
</div>
